import { EditOutlined } from '@mui/icons-material';
import { IconButton, Paper, Stack, Typography } from '@mui/material';
import React from 'react';

interface Props {
  title: string;
  titleAdornment?: React.ReactNode;
  editButtonId: string;
  onEditClick: () => void;
  spacing: number;
  children: React.ReactNode;
}

const EditableCard: React.FC<Props> = ({ title, titleAdornment, editButtonId, onEditClick, spacing, children }) => {
  return (
    <Paper
      elevation={3}
      sx={{
        [`#${editButtonId}`]: { visibility: 'hidden', opacity: 0 },
        [`&:hover #${editButtonId}`]: { visibility: 'visible', opacity: 1 },
        '@media (hover: none)': { [`#${editButtonId}`]: { visibility: 'visible', opacity: 1 } },
        transition: 'opacity 0.5s ease-in-out',
        padding: '24px',
        borderRadius: 1,
        width: '100%'
      }}
    >
      <Stack spacing={spacing}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
          <Stack direction="row" alignItems="center" minWidth={0} flexGrow={1}>
            <Typography variant="h5">{title}</Typography>
            {titleAdornment}
          </Stack>
          <IconButton onClick={onEditClick} id={editButtonId} sx={{ padding: '4px' }}>
            <EditOutlined />
          </IconButton>
        </Stack>
        {children}
      </Stack>
    </Paper>
  );
};

export default EditableCard;
